import React from 'react';
import { FilterX } from 'lucide-react';

// "Reset filters" for a list or report: shown only while something differs
// from the page's defaults, with the number of filters that do. It never
// touches the date range or the table sort — those are not filters.
export function ResetFiltersButton({ count, onReset }) {
  if (!count) return null;
  return (
    <button
      type="button"
      className="text-button reset-filters"
      onClick={onReset}
    >
      <FilterX size={20} aria-hidden="true" />
      Reset filters
      <span className="reset-filters-count" aria-label={`${count} active`}>
        {count}
      </span>
    </button>
  );
}
